<template>
  <div style="padding: 20px">
      <!-- 查询条 -->
      <el-form :inline="true">
        <el-form-item>
          <el-input style="width: 180px" v-model="query.coachName" placeholder="教练姓名"
                    clearable @keyup.enter="handleSearch"/>
        </el-form-item>
        <el-form-item>
          <select-area size="" @areaListId="getAreaListId"/>
        </el-form-item>
        <el-form-item>
          <el-date-picker
              :clearable="false"
              v-model="choiceDate"
              type="month"
              placeholder="请选择月份"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="handleSearch">搜索</el-button>
          <el-button icon="RefreshLeft" @click="handleReset">重置</el-button>
          <el-popconfirm @confirm="exportFile" title="确定要导出吗？">
            <template #reference>
              <el-button type="primary" icon="Download">导出</el-button>
            </template>
          </el-popconfirm>
        </el-form-item>
      </el-form>

      <!-- 列表 -->
      <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%;height: 600px">
        <el-table-column label="教练ID" prop="coachId" width="90" align="center"/>
        <el-table-column label="教练名" prop="coachName" width="110" align="center" show-overflow-tooltip/>
        <el-table-column label="城市" width="100" align="center" show-overflow-tooltip>
          <template #default="scope">{{ scope.row.cityName || '-' }}</template>
        </el-table-column>
        <el-table-column label="校区" prop="areaName" min-width="140" align="center" show-overflow-tooltip/>
        <el-table-column label="类型" width="100" align="center">
          <template #default="scope">
            <el-tag size="small" effect="plain">{{ areaFlagText(scope.row.areaFlag) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="部门" prop="deptName" min-width="140" align="center" show-overflow-tooltip/>
        <el-table-column label="年" prop="year" width="70" align="center"/>
        <el-table-column label="月" prop="month" width="60" align="center"/>
        <el-table-column label="管辖总目标" width="110" align="center">
          <template #default="scope">{{ formatMoney(scope.row.governmentTarget) }}</template>
        </el-table-column>
        <el-table-column label="个人总目标" width="110" align="center">
          <template #default="scope">{{ formatMoney(scope.row.target) }}</template>
        </el-table-column>
        <el-table-column label="确认时间" width="170" align="center">
          <template #default="scope">{{ formatTime(scope.row.signTime) }}</template>
        </el-table-column>
        <el-table-column label="签字" width="90" align="center">
          <template #default="scope">
            <el-image
                v-if="scope.row.signUrl"
                :src="scope.row.signUrl"
                :preview-src-list="[scope.row.signUrl]"
                :preview-teleported="true"
                fit="contain"
                style="width: 50px;height: 34px;border-radius: 4px;background: #f5f7fa"
            />
            <span v-else style="color: #c0c4cc">-</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination background
                       layout="total, sizes, prev, pager, next"
                       :page-sizes="[5, 10, 15, 20]"
                       :current-page="query.pageIndex"
                       :page-size="query.pageSize"
                       :total="total"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"/>
      </div>
  </div>
</template>

<script>
import selectArea from '@/components/SelectArea'
import {confirmTargetList, exportConfirmTarget} from '@/api/performanceTarget'

export default {
  name: 'ConfirmTarget',
  components: {selectArea},
  data() {
    return {
      tableLoading: false,
      tableData: [],
      total: 0,
      choiceDate: new Date(),
      // el-pagination 的 size-change 在「当前页超出新总页数」时会连带触发一次 current-change，
      // 用这个标记屏蔽掉那一次，避免重复请求、页码被夹走
      sizeChanging: false,
      query: {
        coachName: '',
        areaIdList: [],
        year: null,
        month: null,
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    getAreaListId(val) {
      this.query.areaIdList = val || []
    },
    handleSearch() {
      this.query.pageIndex = 1
      this.getData()
    },
    handleReset() {
      this.query.coachName = ''
      this.query.areaIdList = []
      this.choiceDate = new Date()
      this.query.pageIndex = 1
      this.getData()
    },
    handlePageChange(val) {
      if (this.sizeChanging) return
      this.query.pageIndex = val
      this.getData()
    },
    handleSizeChange(val) {
      this.sizeChanging = true
      this.query.pageSize = val
      this.query.pageIndex = 1
      this.getData()
      this.$nextTick(() => {
        this.sizeChanging = false
      })
    },
    /** 组装查询参数：日期选择器拆成 year/month */
    buildQuery() {
      if (this.choiceDate != null) {
        const list = this.getYearAndMonth(this.choiceDate)
        this.query.year = list[0]
        this.query.month = list[1]
      } else {
        this.query.year = null
        this.query.month = null
      }
      return this.query
    },
    getData() {
      this.tableLoading = true
      confirmTargetList(this.buildQuery()).then(res => {
        if (res && res.code === 200 && res.data) {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error((res && res.message) || '获取确认记录失败')
        }
      }).catch(() => {
        this.tableData = []
        this.total = 0
        this.$message.error('获取确认记录失败，请稍后重试')
      }).finally(() => {
        this.tableLoading = false
      })
    },
    /** 导出 */
    exportFile() {
      exportConfirmTarget(this.buildQuery())
      this.$message.success("导出中，请稍后右上角查看！")
    },
    getYearAndMonth(val) {
      const date = new Date(val)
      let month = date.getMonth() + 1
      month = month < 10 ? ('0' + month) : month
      return [date.getFullYear(), month]
    },
    /** 类型 1中招 2少年 4高考 5幼儿 */
    areaFlagText(flag) {
      const map = {1: '中招', 2: '少年', 4: '高考', 5: '幼儿'}
      return map[flag] || (flag == null ? '-' : flag)
    },
    formatMoney(val) {
      if (val == null || val === '') return '-'
      return val
    },
    formatTime(val) {
      if (!val) return '-'
      return String(val).replace('T', ' ').substring(0, 19)
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
